import { AntSelectOption, AntSelectPropsGeneric, AntSelectValue } from 'controls/react/ant/ant-select/types';
import { BaseOptionType } from '@rc-component/select/lib/Select';
import React from 'react';
import { getValueField } from 'controls/react/ant/ant-select/utils/getValueField';
import { getLabelField } from 'controls/react/ant/ant-select/utils/getLabelField';

export function sortByField(a: AntSelectOption, b: AntSelectOption, fieldName: string) {
	// AntSelectOption's index signature types field access as `any` - sort keys are always
	// primitives (string/number) at runtime, just not provable through the generic option shape
	const aValue = a[fieldName] as unknown as string | number | undefined;
	const bValue = b[fieldName] as unknown as string | number | undefined;
	return aValue?.toString().localeCompare(bValue?.toString(), undefined, { sensitivity: 'accent' });
}

//does not work in uncontrolled mode
export function useSortedValues<VT extends AntSelectValue, OptionType extends BaseOptionType>(
	props: AntSelectPropsGeneric<VT, OptionType>,
) {
	const { value, sortValues, ...rest } = props;

	const sortedValue = React.useMemo(() => {
		if (!props.value) {
			return props.value;
		}

		if (!props.options || (!sortValues && props.mode != 'tags' && props.mode != 'multiple')) {
			return value;
		}

		let values = props.value as VT[];
		if (!values) {
			values = [];
		}

		//we need to sort selected values by names and not by values
		//so we are looking for names in children collection
		const valueField = getValueField(props);
		const labelField = getLabelField(props);
		const selectedObjects = values.map((value) => {
			const object = props.options.find((node) => node[valueField] == value);
			return object == null ? { [valueField]: value, [labelField]: value } : object;
		});

		selectedObjects.sort((a, b) => sortByField(a, b, labelField));

		return selectedObjects.map((x) => (x as AntSelectOption)[valueField] as VT);
	}, [props.value, props.options, props.sortValues, props.fieldNames?.value, props.fieldNames?.label]);

	return {
		value: sortedValue as VT,
		...rest,
	};
}
